import { createContext, RefObject } from 'react';
import { ManuscriptEditorRef } from './ManuscriptEditor';

export const ManuscriptContext = createContext<{
  manuscriptEditorRef?: RefObject<ManuscriptEditorRef>;
}>({});
